import { TextField } from "@mui/material";

import { SearchAsYouTypeBoxProps, useSearchAsYouTypeBox } from "../Hooks/useSearchAsYouTypeBox";


const SearchAsYouTypeBox = (props: SearchAsYouTypeBoxProps) => {
    const { handleQueryValueChange, getLabel, getPlaceholder, internalQueryValue } = useSearchAsYouTypeBox(props);
  
    return (
        <TextField
          id={props.id}
          size="small"
          value={internalQueryValue}
          label={getLabel()}
          placeholder={getPlaceholder()}
          onChange={(e) => handleQueryValueChange(e.target.value)}
          disabled={props.disabled}
          className={props.className}
          sx={{ width: { xs: '100%', sm: '100%', md: '500px' } }}
        />
    );
  };
  
  export default SearchAsYouTypeBox;